// extracted by mini-css-extract-plugin
export var alertList = "alert-list-module--alert-list--X5hdj";